import UdeskLocales from 'UdeskLocales';
import React, { FC, memo } from 'react';
import { Button, Input, Space } from 'udesk-ui';
import Value, { TemplateProps as ValueTemplateProps } from './components/Value';
import { AddOutlined, IndeterminateCircleOutlined } from '@udesk/icons';
import { Action, Item, Wrapper } from './components';

export interface TemplateProps {
    value?: (ValueTemplateProps['value'] & {
        variateKey?: string;
    })[];
    onChange?: (value: TemplateProps['value']) => void;
    dataSourceList?: number[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, dataSourceList } = props;
    const onDel = (idx: number) => {
        onChange?.([...(value || []).filter((item, _idx) => idx !== _idx)]);
    };

    const onAdd = () => {
        onChange?.([
            ...(value || []),
            {
                type: 1,
                associateDataFieldList: undefined,
            },
        ]);
    };

    const onKeyChange = (idx: number, v: string) => {
        onChange?.(
            value?.map((item, _idx) => {
                if (idx === _idx) {
                    return {
                        ...item,
                        variateKey: v,
                    };
                } else {
                    return item;
                }
            })
        );
    };

    const onValueChange = (idx: number, v?: ValueTemplateProps['value']) => {
        onChange?.(
            value?.map((item, _idx) => {
                if (idx === _idx) {
                    return {
                        ...item,
                        ...v,
                    };
                } else {
                    return item;
                }
            })
        );
    };

    return (
        <Wrapper>
            {value?.map(({ variateKey, ..._value }, idx) => {
                return (
                    <Item key={idx}>
                        <Space>
                            <Input
                                value={variateKey}
                                onChange={(e) => onKeyChange(idx, e.target.value)}
                                style={{ width: 150 }}
                                placeholder={/* 请输入key */UdeskLocales['current'].pages.semanticIntelligence.aiAgent.detail.components.paramsList.index.pleaseEnterKey}
                            />

                            <span>=</span>

                            <Value
                                value={_value}
                                onChange={(v) => onValueChange(idx, v)}
                                dataSourceList={dataSourceList}
                            />

                            <IndeterminateCircleOutlined onClick={() => onDel(idx)} />
                        </Space>
                    </Item>
                );
            })}

            <Action>
                <Button size="small" type="dashed" onClick={() => onAdd()}>
                    <AddOutlined />
                    {/* 添加接口参数 */}
                    {
                        UdeskLocales['current'].pages.semanticIntelligence.externalInterface.detail
                            .components.paramsList.index.addInterfaceParameters
                    }
                </Button>
            </Action>
        </Wrapper>
    );
});

export default Template;
